import { TeamUserClient } from '../types'

export const updateUser = (base: TeamUserClient) => (userId: string, permissions: string) =>
  base.requester.put<any>(userId, {permissions}, { withCredentials: true })
